export * from '@fhs/routing/src/routes/(tabs)/index';
export { default } from '@fhs/routing/src/routes/(tabs)/index';
